/* -------------------------------------------

	Name:		Sade
	Date:		2022/05/08

---------------------------------------------  */
/*global jQuery, document, window, yall, setTimeout */
var i = 0,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)'),
	isMobile = false;
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}

function isTouchDevice() {
	"use strict";
	if (window.matchMedia("(pointer: coarse)").matches) {
		return true;
	} else {
		return false;
	}
}
if (window.mobileCheck() || isTouchDevice()) {
	isMobile = true;
}
document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = document.documentElement,

		footer_id = document.getElementById('footer'),
		footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],
		input_number = $(document.querySelectorAll('input[type="number"]')),

		email_tag = document.getElementsByClassName('email'),
		list_news = $(document.getElementsByClassName('list-news')),
        list_product = $(document.getElementsByClassName('list-product')),

		Default = {
			utils: {
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
						}).forEach(function (el) {
							el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
							if (el.tagName.toLowerCase() === 'a') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				forms: function () {
					if (input_number.length) {
						input_number.semanticNumber().closest('.input-amount').addClass('has-btn');
					}

				},
				date: function () {
					if (footer_date.length) {
						footer_date[0].innerText = (new Date()).getFullYear();
					}
				},
        shopify: function() {
          
          /**
           * Activate 'remove' links from cart after refresh
           */
          function initRemoveItem() { 
            $('.list-cart .remove').on('click', function(e) { 
              e.preventDefault();
  
              var str_variant_id = $(this).attr('data-variant-id');
              var variant_id = parseInt(str_variant_id);
              
              Shopify.removeItem(variant_id, function() {
                refreshCart();
              });
              
              return false;
            });
          }
          initRemoveItem();

          /**
           * Get custom image from shopify's CDN
           */
          function getImageWithCustomRatio(src_image, params) {
            var imageArr = src_image.split('.');
            var location = imageArr.length - 2;
            var oldStr = imageArr[location];
            imageArr[location] = oldStr + params;
            var imageWithCustomRatio = imageArr.join('.');
            return imageWithCustomRatio;
          }

          $('#singleAddToCart').on('click', function(e) {
            var button = $(this);
            e.preventDefault();
            var id = $('input[name=id]').val(),
              quantity = $('input[name=quantity]').val();
            console.log(id);
            if (id && id != '') { 
              $(button).text('מוסיף לסל...');
              
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: { items: [{ quantity: quantity, id: parseInt(id)}] },
                success: function() {
                  $(button).text('המוצר נוסף לסל הקניות');
                  setTimeout(function() {
                    html_tag.classList.add('cart-active');
                  }, 1000);
                },
                error: function(response) {
                  $(button).text('המוצר לא זמין');
                }
              }).always(function(){
                window.refreshCart();
                setTimeout(function() {
                  $(button).text('הוספה לסל');
                }, 1500);
              });
            } else { 
              
            }
          });

          $('.quick-add').on('click', function(e) {
            e.preventDefault();
            var item_id = $(this).attr('data-variant-id');
            console.log(item_id);

            fbq('track', 'AddToCart');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 'quantity': 1, 'id': item_id })
            })
            .then(response => {
                window.refreshCart();
                console.log(response);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            
            return false;
          });

          /**
           * Product Functions
           */
          if ($('.module-product').length) {
            function detectVariant() {
              var searchArr = [];
              $('#singleProductForm select').each(function() {
                var selectedVal = $(this).val();
                searchArr.push(selectedVal);
              });
  
              metaData['variants'].forEach((variant) => {
                if (variant['options'].equals(searchArr)) {
                  if (variant['available'] == false) { 
                    $('button#singleAddToCart').attr('disabled', true);
                    $('button#singleAddToCart').text('לא במלאי');
                  } else {
                    $('button#singleAddToCart').attr('disabled', false);
                    $('button#singleAddToCart').text('הוספה לסל');
                  }
                  $('#variantPrice').text(Shopify.formatMoney(variant['price'], '${{amount_no_decimals}}'))
                  $('input[name=id]').val(variant['id']);
                  console.log(variant['id']);
                }
              });
            }
            detectVariant();
  
            $('.module-product').find('select').on('change', function(){
              detectVariant();
            });
          }

          // update cart values from .input-amount
          function updateCartValues() {
              $('.list-cart .input-amount a').on('click', function() {
                  var input = $(this).parent().children('input');
                  input.css({ 'opacity': '0.5' });

                  var quantity = input.val(),
                  line = input.attr('data-index');

                  fetch('/cart/change.js', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ 'quantity': quantity, 'line': line })
                  })
                  .then(response => {
                      refreshCart();
                      console.log(response);
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  });

                  return false;
              });
          }
          updateCartValues();

          // $('#cart').on('submit', function(e) {
          //   e.preventDefault();
          //   window.location.href = '/checkout';  
          // })

          const checkbox = document.getElementById('approveTerms');
          const button = document.getElementById('approveButton');
          
          checkbox.addEventListener('change', function() {
            console.log('changed');
            button.disabled = !this.checked; // Disable button when unchecked, enable when checked
          });

          /**
           * Refresh Cart function
           */
          window.refreshCart = function() {

            $.getJSON("/cart.js", function(json) {
              $('#cartIcon').html('<span>'+json.item_count+'</span>');
              $('.list-cart li').remove(); // clean old items

              // Header subtotal must reflect the CURRENT total on every refresh,
              // including when the cart just went empty (delete of last item).
              $('#cart header #headerSubtotal span').html(Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ₪'));

              var itemsArr = [];

              if (json.item_count > 0) {
                // update .list-cart
                var index = 1;
                json.items.forEach(item => {

                  // Item Options String
                  var optionsString = "";
                  if (item.product_has_only_default_variant == false) {
                    item.options_with_values.forEach(option => {
                      optionsString += '<li><span>'+option.name + "</span>" + option.value + "</li>";
                    });
                  } 

                  itemsArr.push(item.id);
                  
                  // Item Image
                  var cart_item_image_mobile = getImageWithCustomRatio(item.image, '_390x365'),
                    cart_item_image_dekstop = getImageWithCustomRatio(item.image, '_220x285');

                  // append item to .list-cart
                  $('.list-cart').append(
                    '<li>'+
                      '<figure>'+
                        '<picture>'+
                          '<source srcset="'+cart_item_image_mobile+'" media="(max-width: 760px)">'+
                          '<img src="'+cart_item_image_dekstop+'" alt="'+item.title+'" width="220" height="285">'+
                        '</picture>'+
                      '</figure>'+
                      '<div>'+
                        '<p><a href="'+item.url+'"><span class="strong">'+item.product_title+'</span><br>'+Shopify.formatMoney(item.original_price, '{{amount_no_decimals}} ₪')+'</a></p>'+
                        '<div class="cols align-middle">'+
                          '<p class="input-amount">'+
                            '<label for="ia'+index+'" class="hidden">כמות</label>'+
                            '<input type="number" id="ia'+index+'" name="ia'+index+'" data-index="'+index+'" value="'+item.quantity+'" data-variant-id="'+item.variant_id+'" required>'+
                          '</p>'+
                          '<p><a href="./" data-variant-id="'+item.variant_id+'" class="remove"><i aria-hidden="true" class="icon-trash"></i> <span class="hidden">Remove</span></a></p>'+
                        '</div>'+
                      '</div>'+
                    '</li>'
                  );
                  index++;                  
                });
                
                $('#cart .input-amount input').semanticNumber().closest('.input-amount').addClass('has-btn');
                
                updateCartValues(); // listen to input amount
                initRemoveItem(); // enable remove

                // Total value
                $('#cart .list-total #cartSubtotal').html('<span>סכום ביניים: </span>'+Shopify.formatMoney(json.original_total_price, '{{amount_no_decimals}} ₪'));
                $('#cart .list-total #cartDiscounts').html('<span>הנחות ומבצעים: </span>'+Shopify.formatMoney(json.total_discount, '{{amount_no_decimals}} ₪'));
                $('#cart .list-total #cartAfterDiscounts').html('<span>סה״כ אחרי הנחות ומבצעים: </span>'+Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ₪'));
                $('#cart .list-total #cartTotal').html('<span>סה״כ לתשלום: </span>'+Shopify.formatMoney(json.total_price, '{{amount_no_decimals}} ₪'));

                // show checkout + note + footer
                $('#cart').removeClass('empty');

              } else { 
                // empty icon
                $('#cartIcon').html('');

                // empty placeholder
                $('.list-cart').append(
                  '<li><p class="text-center">עגלת הקניות שלכם ריקה</p></li>'
                );

                // remove total
                $('#cart #cartTotal').html('');

                // hide checkout + note + footer
                $('#cart').addClass('empty');
              }
            });
          }
          window.refreshCart();
        },
				owl: function () {
					if (list_news.length) {
						list_news.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 0,
									items: 1,
									rtl: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
          if (list_product.length) {
						list_product.each(function () {
							if ($(this).children().length > 1) {
                $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
								$(this).next('.mobile-only').owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: true,
									dots: true,
									autoHeight: true,
									lazyLoad: true,
									margin: 0,
									items: 1,
									rtl: true,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
                console.log('done');
							}
						});
					}
				},
				mobile: function () {
					if (isMobile) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				}
			}

		};
	setTimeout(function () {
		Default.utils.mails();
		Default.utils.forms();
		Default.utils.owl();
        Default.utils.shopify();
		Default.utils.date();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/
